import type { ILead } from 'src/services/api/leads/types';
import { insertLeadByInsertedAt } from 'src/services/api/leads/lead-ordering';

export const getCoapplicants = (
    lead: ILead,
    cachedLeads: ILead[] | undefined,
): ILead[] => {
    const groupId = lead.coapplicant_leads_group_id;
    if (groupId === null || !cachedLeads) {
        return [];
    }

    return cachedLeads.filter((candidate) => (
        candidate.uuid !== lead.uuid &&
        candidate.coapplicant_leads_group_id === groupId
    ));
};

export const reconcileCoapplicantCollection = (
    cachedLeads: ILead[] | undefined,
    returnedLeads: ILead[],
    groupIdsToClear: ReadonlySet<number>,
): ILead[] => {
    const returnedByUuid = new Map(returnedLeads.map((lead) => [lead.uuid, lead]));
    const cached = cachedLeads ?? [];
    const reconciled = cached.map((lead) => {
        const returnedLead = returnedByUuid.get(lead.uuid);
        if (returnedLead) {
            return returnedLead;
        }
        if (
            lead.coapplicant_leads_group_id !== null &&
            groupIdsToClear.has(lead.coapplicant_leads_group_id)
        ) {
            return { ...lead, coapplicant_leads_group_id: null };
        }
        return lead;
    });
    const cachedUuids = new Set(cached.map((lead) => lead.uuid));

    return returnedLeads
        .filter((lead) => !cachedUuids.has(lead.uuid))
        .reduce(insertLeadByInsertedAt, reconciled);
};
